import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useIconProps } from '../useIconProps';

var Close = function Close(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M4.14 11.184a.48.48 0 00.68.678l3.179-3.18 3.202 3.203a.48.48 0 00.68-.679L8.677 8.004l3.184-3.185a.48.48 0 10-.678-.678L7.998 7.325 4.836 4.162a.48.48 0 10-.68.678L7.32 8.004l-3.18 3.18z"
  }));
};

Close.displayName = 'Close';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Close.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Close;